"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableSearchParams = void 0;
const mobx_1 = require("mobx");
class ObservableSearchParams {
    constructor(init, opts = {}) {
        Object.defineProperty(this, "opts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: opts
        });
        Object.defineProperty(this, "search", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        mobx_1.makeObservable(this);
        this.opts = Object.assign({ skipEmpty: true, joinArrays: false, joinArraysWith: "," }, opts);
        this.search = this.normalize(init);
        this.searchParams = new URLSearchParams(init);
        return new Proxy(this, {
            getPrototypeOf(target) {
                return URLSearchParams.prototype;
            },
            get: (target, prop, context) => {
                let fieldRef = Reflect.get(target, prop, context);
                // handle native URLSearchParams()-api updates via proxy-object
                if (!(prop in target)) {
                    fieldRef = Reflect.get(this.searchParams, prop, context);
                    if (typeof fieldRef === "function") {
                        return (...args) => {
                            let oldValue = this.searchParams.toString();
                            let result = Reflect.apply(fieldRef, this.searchParams, args);
                            let newValue = this.searchParams.toString();
                            let isChanged = oldValue !== newValue;
                            if (isChanged) {
                                this.replace(newValue);
                            }
                            return result;
                        };
                    }
                }
                return fieldRef;
            },
        });
    }
    normalize(search = "") {
        const { joinArrays, joinArraysWith, skipEmpty } = this.opts;
        const params = {};
        const normalizedParams = [];
        Array.from(new URLSearchParams(search)).forEach(([param, value]) => {
            var _a;
            if (skipEmpty && !value)
                return;
            const values = joinArraysWith ? value.split(joinArraysWith) : [value];
            (_a = params[param]) !== null && _a !== void 0 ? _a : (params[param] = []);
            params[param].push(...values);
        });
        Object.entries(params).forEach(([name, values]) => {
            if (joinArrays) {
                normalizedParams.push([name, values.join(joinArraysWith)]);
            }
            else {
                const multiParamsWithSameKey = values.map(value => [name, value]);
                normalizedParams.push(...multiParamsWithSameKey);
            }
        });
        return new URLSearchParams(normalizedParams).toString();
    }
    replace(search) {
        search = this.normalize(search);
        if (this.search !== search) {
            this.search = search;
            this.searchParams = new URLSearchParams(search);
        }
    }
    merge(search) {
        search = this.normalize(search);
        this.replace(`${this.search}&${search}`);
    }
    deleteAll() {
        this.search = "";
        Array.from(this.searchParams.keys()).forEach(key => {
            this.searchParams.delete(key);
        });
    }
    getAll(param) {
        const values = this.searchParams.getAll(param);
        const { joinArrays, joinArraysWith } = this.opts;
        if (joinArrays) {
            return values.flatMap(param => param.split(joinArraysWith));
        }
        return values;
    }
    toString({ withPrefix = false } = {}) {
        if (!this.search)
            return "";
        return `${withPrefix ? "?" : ""}${this.search}`;
    }
}
__decorate([
    mobx_1.observable
], ObservableSearchParams.prototype, "search", void 0);
__decorate([
    mobx_1.observable.ref
], ObservableSearchParams.prototype, "searchParams", void 0);
__decorate([
    mobx_1.action
], ObservableSearchParams.prototype, "replace", null);
__decorate([
    mobx_1.action
], ObservableSearchParams.prototype, "deleteAll", null);
exports.ObservableSearchParams = ObservableSearchParams;
